export default "__VITE_ASSET__YtxB504x__"